import script from "./xianxiazuoye.vue?vue&type=script&setup=true&lang=js"
export * from "./xianxiazuoye.vue?vue&type=script&setup=true&lang=js"

import "./xianxiazuoye.vue?vue&type=style&index=0&id=4dc49225&lang=less&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4dc49225"]])

export default __exports__